module.exports = __webpack_public_path__ + "static/dane-d2e06e81baaccbd1bd2b71060fc0f30b.png";